<!-- Reset centrale Modal-->
<template>
    <b-modal
      :visible="visible" 
      @hidden="hide" 
      @change="change"
      @show="fillModal"
      :hide-footer="footer_hide"
      ok-only
      ref="modal"
      id="modal-reset-cu"
      :addCu="addCu"
      :title="$t('reset_cu_modal.title')"
      :ok-title="$t('reset_cu_modal.button_reset_cu')"
      :cancel-title="$t('reset_cu_modal.button_cancel')"
      @ok="handleReset"
    >
      <b-form-group v-if="form_seen">
        <label class="typo-label" for="label-cu-serial">{{
          $t("id_cu")
        }}</label>
        <b-form-input class="typo-name-label" v-model="cuSerial"></b-form-input>
      </b-form-group>

      <b-form-group v-if="form_seen">
        <label class="typo-label" for="label-cu-type">{{
          $t("details_cu_modal.cu_type")
        }}</label>
        <b-form-input class="typo-name-label" v-model="cuType">
        </b-form-input>
      </b-form-group>

      <b-form-group v-if="form_seen">
        <label class="typo-label" for="label-cu-desc">{{
          $t("details_cu_modal.cu_descrizione")
        }}</label>
        <b-form-input class="typo-name-label" v-model="cuDesc">
        </b-form-input>
      </b-form-group>

      <b-row v-if="confirm_seen">
        <b-col sm="12">
          <div class="text-center">
            <i
              class="fa fa-4x fa-exclamation-triangle"
              style="color: orange"
              aria-hidden="true"
            ></i>
          </div>
          <div class="text-center mt-3 mb-3">
            <strong>{{ $t("central_unit") }} {{ this.cuSerial }}</strong>
          </div>
          <div class="text-center mt-3 mb-3">
            {{ $t("reset_cu_modal.confirm") }}
          </div>
          <div class="d-flex justify-content-center">
            <div v-if="spinner" class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="response_seen">
        <b-col sm="12">
          <div class="text-center">
            <i
              class="fa fa-4x fa-check"
              style="color: green"
              aria-hidden="true"
            ></i>
          </div>
          <div class="text-center mt-3 mb-3">{{ reset_response }}</div>
        </b-col>
      </b-row>
      <b-row v-if="error_seen">
        <b-col sm="12">
          <div class="text-center">
            <i
              class="fa fa-4x fa-exclamation-triangle"
              style="color: orange"
              aria-hidden="true"
            ></i>
          </div>
          <div class="text-center mt-3 mb-3">{{ reset_error }}</div>
          <hr>

        </b-col>
      </b-row>
    </b-modal>
</template>

<script>
export default {
  name: "ResetCentralUnit",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    cu: {
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cuSerial: "",
      cuType: "",
      cuDesc:"",
      addCu: "false",
      confirm: 0,
      response_seen: false,
      error_seen: false,
      footer_hide: false,
      confirm_seen: false,
      form_seen: true,
      reset_error: null,
      reset_response: null,
      spinner: false,
      plantUnits: this.$store.state.plantUnits
    };
  },
 
  methods: {
    hide() {
      this.$emit("hide");
    },
    change(visible) {
      this.$emit("change", visible);
    },
    fillModal() {
      this.cuType="";
      this.cuSerial="";
      this.cuDesc="";
      if(this.cu)
      {
        this.cuType=this.cu.cu_type;
        this.cuSerial=this.cu.cu_id;
        this.cuDesc=this.cu.cu_desc;
      }
      this.response_seen = false;
      this.error_seen = false;
      this.footer_hide = false;
      this.form_seen = true;
      this.confirm_seen = false;
      this.error_seen = false;
      this.spinner = false;
      this.confirm = 0;
      this.reset_error="";
    },
    handleReset(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();

      if(this.reset_error==null || this.reset_error=="")
      {
      // Controllo se è già stata inviata la conferma oppure no
      if (this.confirm == 0) {
        this.form_seen = false;
        this.confirm_seen = true;
      }
      if (this.confirm == 1) {
        console.log("CONFIRM: ", confirm);
        this.spinner = true;
        this.footer_hide = true;
        this.$store.dispatch("resetCu", {
          serial: this.cuSerial,
          type: this.cuType,
        });

       // Hide the modal manually
       this.$nextTick(() => {
        this.$refs.modal.hide();
      });
      }
      this.confirm++;
      
      }
  
    },


  },
};
</script>
